import isEmpty from 'lodash/isEmpty';
import { useFlags } from 'launchdarkly-react-client-sdk';

import type { GqlFilteredSpecialsQuery, GqlFilteredSpecialsV2Query, GqlSpecials, GqlProducts } from 'types/graphql';
import { useFilteredSpecialsV2Query, useFilteredSpecialsQuery } from 'types/graphql';

export type ProductOffersInput = Pick<GqlProducts, 'DispensaryID' | 'specialData'>;

export default function useProductOffers(product: ProductOffersInput): { specials: GqlSpecials[]; loading: boolean } {
  const flags = useFlags();
  const useV2Query = flags['fintech.cats.use-filteredSpecialsV2-outside-admin.rollout'];

  const queryHook = useV2Query ? useFilteredSpecialsV2Query : useFilteredSpecialsQuery;

  const { data, loading } = queryHook({
    skip: isEmpty(product.specialData?.bogoSpecials),
    variables: {
      specialsFilter: {
        dispensaryId: product.DispensaryID,
        current: true,
        specialIds: (product.specialData?.bogoSpecials ?? [])
          .map((s) => s?.specialId)
          .filter((id): id is string => id != null),
      },
    },
  });

  const specials = (
    (data as GqlFilteredSpecialsV2Query | undefined)?.filteredSpecialsV2?.specials ??
    (data as GqlFilteredSpecialsQuery | undefined)?.filteredSpecials?.specials ??
    []
  ).filter((s): s is GqlSpecials => s != null);

  return { specials, loading };
}
